import { useFeatureNavigation } from '@/hooks/useFeatureNavigation';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { type FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';

interface FeatureNavigatorProps {
  className?: string;
}

export const FeatureNavigator: FunctionComponent<FeatureNavigatorProps> = ({ className }) => {
  const { canNavigatePrev, canNavigateNext, currentIndex, totalCount, navigatePrev, navigateNext, hasNavigation } =
    useFeatureNavigation();
  const { t } = useTranslation('components');

  // Don't render if there's no navigation context or only one feature
  if (!hasNavigation) {
    return null;
  }

  return (
    <div className={`flex items-center justify-between gap-2 ${className || ''}`}>
      <Button
        variant='outline'
        size='icon'
        onClick={navigatePrev}
        disabled={!canNavigatePrev}
        aria-label={t('featureNavigator.previousFeature')}>
        <ChevronLeft />
      </Button>

      <span className='text-sm text-muted-foreground whitespace-nowrap'>
        {t('featureNavigator.featureOf', { current: currentIndex + 1, total: totalCount })}
      </span>

      <Button
        variant='outline'
        size='icon'
        onClick={navigateNext}
        disabled={!canNavigateNext}
        aria-label={t('featureNavigator.nextFeature')}>
        <ChevronRight />
      </Button>
    </div>
  );
};
